import type { CampaignTypeName } from "@decibeltrade/sdk";

export function resolveCampaignDisplay(args: {
  campaignId: string | undefined;
  campaignType: CampaignTypeName | undefined;
  chainTitle: string | undefined;
  chainDescription: string | undefined;
  byIdLookup: (key: string) => string | null;
  byTypeLookup: (key: string) => string | null;
  fallbackTitle: string;
}): { displayTitle: string; displayDescription: string | undefined } {
  const {
    campaignId,
    campaignType,
    chainTitle,
    chainDescription,
    byIdLookup,
    byTypeLookup,
    fallbackTitle,
  } = args;
  const lookup = (field: "title" | "description") =>
    (campaignId ? byIdLookup(`${campaignId}.${field}`) : null) ??
    (campaignType ? byTypeLookup(`${campaignType}.${field}`) : null);
  return {
    displayTitle: lookup("title") ?? chainTitle ?? fallbackTitle,
    displayDescription: lookup("description") ?? chainDescription,
  };
}
